<div class="input-group">

    <div class="btn-group" dropdown>
        <button id="button-basic2" dropdownToggle type="button" class="btn btn-primary dropdown-toggle"
                aria-controls="dropdown-basic">
            {{ dom_elements.statuses[refillsHandlerService.refills_list_props.status_attivo] }}
            <span class="caret"></span>
        </button>

        <ul id="dropdown-basic2" *dropdownMenu class="dropdown-menu"
            role="menu" aria-labelledby="button-basic">
            <li role="menuitem" *ngFor="let status of dom_elements.statuses; let i = index">
                <a class="dropdown-item" (click)="statoFilterChanged(i)" >
                    {{status}}
                </a>
            </li>
        </ul>
    </div>
    <input type="text" class="form-control" aria-label="filtro" disabled [ngModel]="'filtra per stato richiesta...'">
</div>

<div class="input-group mt-3">
    <!--<div class="btn-group" dropdown>
    <button id="button-basic" dropdownToggle type="button" class="btn btn-default dropdown-toggle"
            aria-controls="dropdown-basic">
      {{dom_elements.filtro_attivo}} <span class="caret"></span>
    </button>

    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
        role="menu" aria-labelledby="button-basic">
      <li role="menuitem"><a class="dropdown-item" *ngIf="authService.is_admin()"
      (click)="filterColumnChanged('refills_expanded.usr_name')">Nome</a></li>
      <li role="menuitem"><a class="dropdown-item"
      (click)="filterColumnChanged('refills_expanded.vhc_plate')">Targa</a></li>
      <li role="menuitem"><a class="dropdown-item" (click)="resetFilter()">annulla</a></li>

    </ul>
  </div>-->
    <input type="text" class="form-control" aria-label="filtro"
           placeholder="filtra per targa, nome, ID veicolo o viaggio..."
           (input)="filterValueChanged($event)"
           [(ngModel)]="refillsHandlerService.refills_list_props.filter_value">

</div>


<div class="input-group">
    <div class="input-group-prepend">
        <div class="input-group-text">
            <input type="checkbox" aria-label="Checkbox for following text input"
                   (change)="startDateUnchecked()"
                   [(ngModel)]="dom_elements.data_inizio_enabled">
        </div>
    </div>
    <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon2">Data inizio</span>
    </div>
    <input type="text"
           [disabled]="!dom_elements.data_inizio_enabled"
           class="form-control"
           #dp="bsDatepicker"
           [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
           (bsValueChange)="startDateChanged($event)"
           bsDatepicker
           [(bsValue)]="refillsHandlerService.refills_list_props.data_inizio">
</div>

<div class="input-group">
    <div class="input-group-prepend">
        <div class="input-group-text">
            <input type="checkbox" aria-label="Checkbox for following text input"
                   (change)="endDateUnchecked()"
                   [(ngModel)]="dom_elements.data_fine_enabled">
        </div>
    </div>
    <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon3">Data fine</span>
    </div>
    <input type="text"
           [disabled]="!dom_elements.data_fine_enabled"
           class="form-control"
           #dp="bsDatepicker"
           [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
           (bsValueChange)="endDateChanged($event)"
           bsDatepicker
           [(bsValue)]="refillsHandlerService.refills_list_props.data_fine">
</div>

